import React from 'react';
import { useSelector } from 'react-redux';
import { OverlayTrigger } from 'react-bootstrap';
import { popover } from '../../common/popover/popover';
import avatar1 from '../../../assits/avatars/1.jpg';
import ClockComp from '../../table/Clock/ClockComp';
import './RightPlayer.scss';
function RightPlayer() {
	const cards = useSelector((state) => state.rightPlayer.cards);
	const clockActive = useSelector((state) => state.rightPlayer.clock);

	return (
		<OverlayTrigger placement="top" overlay={popover}>
			<div className="player pright" data-active="0">
				<div className="bcards">
					<div className="hand">
						{cards.map((card, idx) => (
							<div key={idx}></div>
						))}
					</div>
				</div>
				<div className="details">
					<i
						className="picture"
						role="img"
						aria-label="profile picture"
						style={{ backgroundImage: `url(${avatar1})` }}
					></i>
					<b>Awixor Houcine</b>
					<span>19</span>
				</div>
				<div className="estimat dice"></div>
				<div className="clock">
					<ClockComp active={clockActive} />
				</div>
			</div>
		</OverlayTrigger>
	);
}

export default RightPlayer;
